import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@mui/material";
import React, { useState } from "react";

const ButtonYesNo = ({
  alertTitle,
  alertDescription,
  buttonText,
  buttonClass = "col-sm-4 col-md-4 col-lg-4 buton-white-black-border",
  onConfirm,
}) => {
  const [open, setOpen] = useState(false);

  const onCancel = () => {
    setOpen(false);
  };

  const handleConfirm = () => {
    setOpen(false);
    onConfirm();
  };

  return (
    <>
      {open && (
        <Dialog open={open} onClose={onCancel}>
          {alertTitle && (
            <DialogTitle>
              <div className="titulo m-3" style={{ fontSize: "30px" }}>
                {alertTitle}
              </div>
            </DialogTitle>
          )}

          {alertDescription && (
            <div
              style={{ fontSize: "20px", padding: "20px", fontWeight: "500" }}
            >
              {alertDescription}
            </div>
          )}

          <DialogActions>
            <button
              className="col-sm-3 col-md-3 col-lg-3 mt20 p-2 buton-white-black-border"
              onClick={onCancel}
            >
              Não
            </button>

            <button
              className="col-sm-3 col-md-3 p-2 col-lg-3 mt20 buton-green"
              onClick={handleConfirm}
              autoFocus
            >
              Sim
            </button>
          </DialogActions>
        </Dialog>
      )}

      <button
        type="button"
        className={buttonClass}
        onClick={() => setOpen(true)}
      >
        {buttonText}
      </button>
    </>
  );
};

export default ButtonYesNo;
